import React from 'react';
import { Grid } from '@material-ui/core';
import LotsPricing from './lotsPricing/LotsPricing';
import UnitsPricing from './unitsPricing/UnitsPricing';

const PricingSection = (props) => {
	const { filteredLotSizeType, filteredUnit, search } = props;

	return (
		<>
			<Grid item container spacing={2} xs={12}>
				<Grid item xs={8}>
					<LotsPricing
						filteredLotSizeType={filteredLotSizeType}
						search={search}
					/>
				</Grid>
				<Grid item xs={4}>
					<UnitsPricing filteredUnit={filteredUnit} search={search} />
				</Grid>
			</Grid>
		</>
	);
};

export default PricingSection;
